import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	sites: {
		id: 'navigation.global-shortcuts.sites',
		defaultMessage: 'sites',
		description: 'The label that appends the product name in the expand menu',
	},
});
